var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 1866 1926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.117 462.413C214.98 475.161 222.369 503.219 209.62 525.083C134.628 653.69 91.6503 803.257 91.6503 963C91.6503 1121.31 133.857 1269.61 207.601 1397.44C220.248 1419.36 212.729 1447.38 190.807 1460.03C168.886 1472.68 140.862 1465.16 128.214 1443.23C46.6515 1301.86 0 1137.81 0 963C0 786.601 47.5042 621.158 130.447 478.916C143.196 457.053 171.254 449.664 193.117 462.413Z",
    fill: "url(#paint0_linear_1128_18062)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M962.329 92.3222C749.101 92.3222 553.881 168.913 402.501 296.135C383.126 312.418 354.219 309.912 337.936 290.537C321.653 271.162 324.16 242.255 343.535 225.973C510.811 85.3901 726.736 0.671875 962.329 0.671875C1318.19 0.671875 1628.87 193.85 1795.33 480.84C1801.43 491.366 1803.1 503.887 1799.97 515.643C1796.83 527.4 1789.15 537.427 1778.61 543.513L1302.36 818.611C1280.49 831.242 1252.53 823.801 1239.83 801.972C1184.2 706.344 1080.73 642.224 962.329 642.224C843.932 642.224 740.458 706.344 684.83 801.972C672.104 823.848 644.053 831.266 622.177 818.54C600.301 805.815 592.883 777.764 605.608 755.888C676.972 633.21 809.974 550.574 962.329 550.574C1098.26 550.574 1218.79 616.356 1293.88 717.668L1691.97 487.719C1536.52 249.573 1267.76 92.3222 962.329 92.3222Z",
    fill: "url(#paint1_linear_1128_18062)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1779.82 1380.31C1801.75 1392.95 1809.28 1420.97 1796.64 1442.89C1630.5 1731.13 1319.12 1925.33 962.328 1925.33C726.282 1925.33 509.982 1840.28 342.571 1699.22C323.217 1682.91 320.748 1654 337.057 1634.65C353.365 1615.29 382.274 1612.82 401.628 1629.13C553.13 1756.79 748.691 1833.68 962.328 1833.68C1285.03 1833.68 1566.79 1658.14 1717.23 1397.13C1729.87 1375.2 1757.89 1367.67 1779.82 1380.31Z",
    fill: "url(#paint2_linear_1128_18062)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M962.328 367.273C633.317 367.273 366.601 633.989 366.601 963C366.601 1292.01 633.317 1558.73 962.328 1558.73C1167.11 1558.73 1347.82 1455.42 1455.09 1297.9L1295.68 1205.89C1220.72 1308.59 1099.35 1375.43 962.328 1375.43C808.764 1375.43 674.865 1291.48 603.92 1167.18C591.374 1145.2 599.022 1117.22 621.002 1104.67C642.982 1092.12 670.971 1099.77 683.517 1121.75C738.817 1218.63 842.994 1283.78 962.328 1283.78C1081.66 1283.78 1185.84 1218.63 1241.14 1121.75C1247.18 1111.16 1257.2 1103.42 1268.97 1100.23C1280.73 1097.05 1293.29 1098.68 1303.85 1104.78L1542.02 1242.26C1563.9 1254.89 1571.43 1282.85 1558.85 1304.76C1440.35 1511.18 1217.62 1650.38 962.328 1650.38C582.7 1650.38 274.951 1342.63 274.951 963C274.951 583.372 582.7 275.623 962.328 275.623C1130.09 275.623 1283.92 335.781 1403.25 435.651C1422.66 451.895 1425.22 480.796 1408.98 500.204C1392.74 519.612 1363.83 522.177 1344.43 505.934C1240.98 419.353 1107.79 367.273 962.328 367.273Z",
    fill: "url(#paint3_linear_1128_18062)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.767 383.77C428.915 383.77 473.258 346.071 483.513 295.955C484.978 288.795 485.748 281.382 485.748 273.79C485.748 213.049 436.508 163.81 375.767 163.81C315.027 163.81 265.787 213.049 265.787 273.79C265.787 334.53 315.027 383.77 375.767 383.77ZM1327.1 546.908C1387.84 546.908 1437.08 497.668 1437.08 436.928C1437.08 376.187 1387.84 326.947 1327.1 326.947C1266.36 326.947 1217.12 376.187 1217.12 436.928C1217.12 497.668 1266.36 546.908 1327.1 546.908ZM1756.02 1527.57C1816.76 1527.57 1866 1478.33 1866 1417.59C1866 1356.85 1816.76 1307.61 1756.02 1307.61C1695.28 1307.61 1646.04 1356.85 1646.04 1417.59C1646.04 1478.33 1695.28 1527.57 1756.02 1527.57ZM757.032 785.198C757.032 845.939 707.792 895.178 647.052 895.178C586.311 895.178 537.071 845.939 537.071 785.198C537.071 724.458 586.311 675.218 647.052 675.218C707.792 675.218 757.032 724.458 757.032 785.198ZM276.785 1417.59C276.785 1478.33 227.545 1527.57 166.805 1527.57C159.212 1527.57 151.799 1526.8 144.64 1525.33C94.5235 1515.08 56.8242 1470.73 56.8242 1417.59C56.8242 1356.85 106.064 1307.61 166.805 1307.61C227.545 1307.61 276.785 1356.85 276.785 1417.59Z",
    fill: "#3779E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_18062",
    x1: 107.933,
    y1: 456.167,
    x2: 107.933,
    y2: 1466.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72454,
    stopColor: "#3779E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3779E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_18062",
    x1: 735,
    y1: 335.5,
    x2: 504,
    y2: 477.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3779E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3779E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_18062",
    x1: 1565.5,
    y1: 1650,
    x2: 1747.5,
    y2: 1463.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3779E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3779E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1128_18062",
    x1: 1116.5,
    y1: 615,
    x2: 1334.5,
    y2: 446.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3779E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3779E1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ce0cec0aef3c41fb520f1b467b292f8.svg";
export { ForwardRef as ReactComponent };